// src/components/DevLogsViewer.tsx
import React, { useContext, useEffect } from "react";
import { Context } from "../../../index"; // убедись, что путь верный
import { observer } from "mobx-react-lite";
import { notify } from "../../../shared/lib/notify";
import "./DevLogsViewer.css";

const DevLogsViewer: React.FC = () => {
  const { store } = useContext(Context);

  useEffect(() => {
    store.fetchDevLogs();
  }, []);

  const handleRefresh = () => {
    store.fetchDevLogs();
  };

  const handleClear = async () => {
    notify.confirm({
      message: "Очистить все системные логи? Это действие нельзя отменить.",
      onConfirm: async () => {
        const success = await store.clearDevLogs();
        if (!success) {
          notify.error(
            "Ошибка при очистке логов. Подробности в консоли или в интерфейсе.",
          );
        }
      },
    });
  };

  return (
    <div className="logs-viewer">
      <div className="logs-toolbar">
        <button
          className="logs-btn logs-btn-refresh"
          onClick={handleRefresh}
          disabled={store.devLogsLoading}
        >
          {store.devLogsLoading ? "Загрузка..." : "Обновить"}
        </button>
        <button className="logs-btn logs-btn-clear" onClick={handleClear}>
          Очистить логи
        </button>
      </div>

      {store.devLogsError && (
        <div className="logs-error">Ошибка: {store.devLogsError}</div>
      )}

      <pre className="logs-content">
        {store._devLogs ||
          (store.devLogsLoading ? "Загрузка логов..." : "Логи пусты")}
      </pre>
    </div>
  );
};

export default observer(DevLogsViewer);
